export default __webpack_public_path__ + "static/media/gallery_03.a41fa4e7.jpg";